import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createBlock as _createBlock, withModifiers as _withModifiers, vModelText as _vModelText } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "reports-header"
}
const _hoisted_2 = { class: "header-icon" }
const _hoisted_3 = { class: "header-text" }
const _hoisted_4 = { class: "reports-body" }
const _hoisted_5 = { class: "reports-sidebar" }
const _hoisted_6 = {
  key: 0,
  class: "period-setup"
}
const _hoisted_7 = { class: "period-year-row" }
const _hoisted_8 = { class: "period-year-value" }
const _hoisted_9 = { class: "period-range-row" }
const _hoisted_10 = { class: "period-range-field" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "period-range-field" }
const _hoisted_13 = ["value", "disabled"]
const _hoisted_14 = { class: "period-buttons period-buttons--months" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "period-hint" }
const _hoisted_17 = {
  key: 1,
  class: "analysis-ledger-block"
}
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "report-text" }
const _hoisted_20 = { class: "report-desc" }
const _hoisted_21 = { class: "period-setup" }
const _hoisted_22 = { class: "ledger-ym-nav" }
const _hoisted_23 = { class: "ledger-ym-value" }
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "approval-setup" }
const _hoisted_26 = { class: "approval-count" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "approval-fields" }
const _hoisted_29 = ["onUpdate:modelValue"]
const _hoisted_30 = { class: "ledger-detail-block" }
const _hoisted_31 = ["disabled", "onClick"]
const _hoisted_32 = { class: "report-text" }
const _hoisted_33 = { class: "report-title" }
const _hoisted_34 = {
  key: 0,
  class: "report-badge"
}
const _hoisted_35 = {
  key: 0,
  class: "ledger-detail-empty"
}
const _hoisted_36 = { class: "reports-main" }
const _hoisted_37 = {
  key: 0,
  class: "reports-empty"
}
const _hoisted_38 = {
  key: 1,
  class: "reports-pdf-panel"
}
const _hoisted_39 = { class: "pdf-toolbar" }
const _hoisted_40 = { class: "pdf-title" }
const _hoisted_41 = { class: "pdf-toolbar-actions" }
const _hoisted_42 = ["href"]
const _hoisted_43 = ["disabled"]
const _hoisted_44 = {
  key: 0,
  class: "pdf-loading"
}
const _hoisted_45 = ["src"]
const _hoisted_46 = {
  key: 3,
  class: "pdf-mobile-fallback"
}
const _hoisted_47 = { class: "fallback-actions" }
const _hoisted_48 = ["href"]
const _hoisted_49 = {
  key: 4,
  class: "reports-empty"
}

import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue';
import { usePageTabNav } from '@/composables/usePageTabNav';
import { bankbookApi } from '@/services/api';
import LoadingOverlay from '@/components/common/LoadingOverlay.vue';
import MemberStampPanel from '@/components/bankbook/MemberStampPanel.vue';
import AccountingAnalysisPanel from '@/components/bankbook/AccountingAnalysisPanel.vue';
import {
  buildAnalysisReferenceErrorHtml,
  buildAnalysisReferenceHtml,
  buildAnalysisReferenceLoadingHtml,
} from '@/components/bankbook/analysisReferencePopupHtml';

interface BeneficiaryMatch {
  cb_idx: number;
  cb_name: string;
  matchType: string;
}

interface ReportItem {
  key: string;
  title: string;
  description?: string;
  icon: string;
  disabled: boolean;
  pdfKey?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BankbookReportsModal',
  props: {
    page: { type: Boolean, default: true },
    memberCode: {},
    currentYear: {},
    currentMonth: {},
    bizGubun: {},
    bankCode: {},
    bankLabel: {},
    cashbookList: {},
    prevMonthBalance: {},
    incomeCodeList: {},
    expenseCodeList: {},
    beneficiaryMatches: {}
  },
  emits: ["change-year-month"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const selectedReport = ref('accounting-analysis');

const clampMonth = (value: number | string | undefined) => {
  const month = parseInt(String(value ?? ''), 10);
  if (!Number.isFinite(month)) return 1;
  return Math.min(12, Math.max(1, month));
};

const analysisStartMonth = ref(clampMonth(props.currentMonth));
const analysisEndMonth = ref(clampMonth(props.currentMonth));
const awaitingEndMonth = ref(false);
const analysisMonthOptions = Array.from({ length: 12 }, (_, i) => ({
  month: i + 1,
  label: `${i + 1}월`,
}));

const analysisPeriodType = computed(() => {
  const start = analysisStartMonth.value;
  const end = analysisEndMonth.value;
  if (start === 1 && end === 6) return 'h1';
  if (start === 7 && end === 12) return 'h2';
  if (start === end) return 'month';
  return 'range';
});

const analysisRange = computed(() => {
  const startMonth = analysisStartMonth.value;
  const endMonth = analysisEndMonth.value;
  let periodName = `${startMonth}~${endMonth}월`;
  if (startMonth === endMonth) periodName = `${startMonth}월`;
  else if (startMonth === 1 && endMonth === 6) periodName = '상반기';
  else if (startMonth === 7 && endMonth === 12) periodName = '하반기';
  else if (startMonth === 1 && endMonth === 12) periodName = '연간';
  return {
    startMonth,
    endMonth,
    label: `${props.currentYear}년 ${periodName}`,
  };
});

const analysisPeriodHint = computed(() => analysisRange.value.label);

const normalizeAnalysisRange = () => {
  const start = clampMonth(analysisStartMonth.value);
  let end = clampMonth(analysisEndMonth.value);
  if (end < start) end = start;
  analysisStartMonth.value = start;
  analysisEndMonth.value = end;
};

const monthButtonClass = (month: number) => {
  const start = analysisStartMonth.value;
  const end = analysisEndMonth.value;
  return {
    active: month === start || month === end,
    'in-range': month > start && month < end,
    'is-pending': awaitingEndMonth.value && month === start,
  };
};

const pickAnalysisMonth = (month: number) => {
  const next = clampMonth(month);
  if (!awaitingEndMonth.value) {
    analysisStartMonth.value = next;
    analysisEndMonth.value = next;
    awaitingEndMonth.value = true;
    return;
  }
  if (next < analysisStartMonth.value) {
    analysisEndMonth.value = analysisStartMonth.value;
    analysisStartMonth.value = next;
  } else {
    analysisEndMonth.value = next;
  }
  awaitingEndMonth.value = false;
};

const resetAnalysisMonths = (month: number | string | undefined) => {
  const next = clampMonth(month);
  analysisStartMonth.value = next;
  analysisEndMonth.value = next;
  awaitingEndMonth.value = false;
};

const onRangeSelectChange = () => {
  awaitingEndMonth.value = false;
  normalizeAnalysisRange();
};

const ledgerMonthPickerRef = ref<HTMLInputElement | null>(null);

const emitYearMonth = (year: number, month: number) => {
  const y = Math.min(2100, Math.max(2000, year));
  const m = clampMonth(month);
  emit('change-year-month', String(y), String(m).padStart(2, '0'));
};

const changeReportYear = (delta: number) => {
  const year = parseInt(props.currentYear, 10) + delta;
  const month = clampMonth(props.currentMonth);
  emitYearMonth(year, month);
};

const changeLedgerMonth = (delta: number) => {
  let year = parseInt(props.currentYear, 10);
  let month = clampMonth(props.currentMonth) + delta;
  if (month < 1) {
    month = 12;
    year -= 1;
  } else if (month > 12) {
    month = 1;
    year += 1;
  }
  emitYearMonth(year, month);
};

const openLedgerMonthPicker = () => {
  const el = ledgerMonthPickerRef.value;
  if (!el) return;
  try {
    if (typeof el.showPicker === 'function') {
      el.showPicker();
      return;
    }
  } catch {
    // showPicker는 사용자 제스처 밖이면 NotAllowedError → click 폴백
  }
  el.focus();
  el.click();
};

const onLedgerMonthPickerChange = (event: Event) => {
  const value = (event.target as HTMLInputElement).value;
  if (!value || !value.includes('-')) return;
  const [yearStr, monthStr] = value.split('-');
  emitYearMonth(parseInt(yearStr, 10), parseInt(monthStr, 10));
};

const LEDGER_DETAIL_KEYS = [
  'income-settlement',
  'expense-settlement',
  'cash-journal',
  'general-ledger',
  'income-resolution',
  'expense-resolution',
  'return-resolution',
  'subsidy-statement',
  'subsidy-income-resolution',
  'subsidy-expense-resolution',
  'donation-statement',
  'donation-income-resolution',
  'donation-expense-resolution',
] as const;
const APPROVAL_PRESETS: Record<number, string[]> = {
  1: ['시설장'],
  2: ['담당자', '시설장'],
  3: ['담당자', '팀장', '시설장'],
  4: ['담당자', '팀장', '부장', '시설장'],
};

const approvalLabels = ref<string[]>([...APPROVAL_PRESETS[1]]);
const pdfLoading = ref(false);
const referencePopupLoading = ref(false);
const pdfPreviewUrl = ref<string | null>(null);
const pdfBlob = ref<Blob | null>(null);
/** 현재 blob/url이 어떤 보고서 PDF인지 (늦게 끝난 장부 요청이 덮어쓰는 것 방지) */
const pdfSourceKey = ref<string | null>(null);
/** 회계분석 PDF가 어떤 기간으로 생성됐는지 (기간 불일치 시 강제 재생성) */
const analysisPdfPeriodKey = ref<string | null>(null);
let pdfRequestSeq = 0;
const analysisData = ref<Record<string, any> | null>(null);

const currentAnalysisPeriodKey = computed(
  () => `${props.currentYear}:${clampMonth(analysisStartMonth.value)}-${clampMonth(analysisEndMonth.value)}`
);

const reportList = ref<ReportItem[]>([
  { key: 'accounting-analysis', title: '회계분석보고서', description: '인건비·생계비·차입 점검', icon: 'mdi-chart-timeline-variant', disabled: false, pdfKey: 'accounting-analysis' },
  { key: 'ledger-book', title: '장부', description: '표지·목차 + 보고서 이어붙임', icon: 'mdi-book-open-variant', disabled: false, pdfKey: 'ledger-book' },
  { key: 'income-settlement', title: '세입결산서', description: '관·항·목 예산/결산', icon: 'mdi-chart-box-outline', disabled: false, pdfKey: 'income-settlement' },
  { key: 'expense-settlement', title: '세출결산서', description: '관·항·목 예산/결산', icon: 'mdi-chart-box-plus-outline', disabled: false, pdfKey: 'expense-settlement' },
  { key: 'cash-journal', title: '현금출납부', description: '전표·입출금·잔액', icon: 'mdi-cash-register', disabled: false, pdfKey: 'cash-journal' },
  { key: 'general-ledger', title: '총계정원장', description: '계정별 수입·지출·차인', icon: 'mdi-book-open-page-variant', disabled: false, pdfKey: 'general-ledger' },
  { key: 'income-resolution', title: '수입결의서', description: '수입 결의 내역', icon: 'mdi-arrow-down-bold-box-outline', disabled: false, pdfKey: 'income-resolution' },
  { key: 'expense-resolution', title: '지출결의서', description: '지출 결의 내역', icon: 'mdi-arrow-up-bold-box-outline', disabled: false, pdfKey: 'expense-resolution' },
  { key: 'return-resolution', title: '반납결의서', description: '반납 결의 내역', icon: 'mdi-backup-restore', disabled: false, pdfKey: 'return-resolution' },
  { key: 'subsidy-statement', title: '정부보조금명세서', description: '보조금 수령 내역', icon: 'mdi-domain', disabled: false, pdfKey: 'subsidy-statement' },
  { key: 'subsidy-income-resolution', title: '보조금 수입결의서', description: '보조금 수입 결의', icon: 'mdi-arrow-down-bold-box-outline', disabled: false, pdfKey: 'subsidy-income-resolution' },
  { key: 'subsidy-expense-resolution', title: '보조금 지출결의서', description: '보조금 지출 결의', icon: 'mdi-arrow-up-bold-box-outline', disabled: false, pdfKey: 'subsidy-expense-resolution' },
  { key: 'donation-statement', title: '후원금내역서', description: '후원금 수입·지출', icon: 'mdi-hand-heart-outline', disabled: false, pdfKey: 'donation-statement' },
  { key: 'donation-income-resolution', title: '후원금 수입결의서', description: '후원금 수입 결의', icon: 'mdi-arrow-down-bold-box-outline', disabled: false, pdfKey: 'donation-income-resolution' },
  { key: 'donation-expense-resolution', title: '후원금 지출결의서', description: '후원금 지출 결의', icon: 'mdi-arrow-up-bold-box-outline', disabled: false, pdfKey: 'donation-expense-resolution' },
]);

const detailReportList = computed(() =>
  LEDGER_DETAIL_KEYS
    .map((key) => reportList.value.find((report) => report.key === key))
    .filter((report): report is ReportItem => !!report)
);

const isDetailReport = (reportKey: string) =>
  (LEDGER_DETAIL_KEYS as readonly string[]).includes(reportKey);

const isLedgerWorkspace = computed(
  () => selectedReport.value === 'ledger-book' || isDetailReport(selectedReport.value)
);

const isAnalysisWorkspace = computed(
  () => selectedReport.value === 'accounting-analysis'
);

const supportsInlinePdf = computed(() => {
  if (typeof navigator === 'undefined') return true;
  const ua = navigator.userAgent || '';
  const iOS = /iPad|iPhone|iPod/.test(ua)
    || (navigator.platform === 'MacIntel' && (navigator.maxTouchPoints || 0) > 1);
  if (iOS) return false;
  if (typeof navigator.pdfViewerEnabled === 'boolean') return navigator.pdfViewerEnabled;
  return true;
});

const loadingText = computed(() => {
  if (selectedReport.value === 'ledger-book') return '장부 생성 중...';
  if (selectedReport.value === 'accounting-analysis') return '분석보고서 불러오는 중...';
  return 'PDF 생성 중...';
});

const currentReportTitle = computed(() => {
  return reportList.value.find((r) => r.key === selectedReport.value)?.title || '';
});

const currentPdfKey = computed(() => {
  const report = reportList.value.find((r) => r.key === selectedReport.value);
  return report?.pdfKey || selectedReport.value;
});

const activePdfPreviewUrl = computed(() => (
  pdfSourceKey.value === currentPdfKey.value ? pdfPreviewUrl.value : null
));

const activePdfBlob = computed(() => (
  pdfSourceKey.value === currentPdfKey.value ? pdfBlob.value : null
));

const revokePdfUrl = () => {
  if (pdfPreviewUrl.value) {
    URL.revokeObjectURL(pdfPreviewUrl.value);
    pdfPreviewUrl.value = null;
  }
  pdfBlob.value = null;
  pdfSourceKey.value = null;
  analysisPdfPeriodKey.value = null;
  analysisData.value = null;
};

const invalidateAnalysisPdfCache = () => {
  if (pdfSourceKey.value === 'accounting-analysis') {
    if (pdfPreviewUrl.value) {
      URL.revokeObjectURL(pdfPreviewUrl.value);
      pdfPreviewUrl.value = null;
    }
    pdfBlob.value = null;
    pdfSourceKey.value = null;
  }
  analysisPdfPeriodKey.value = null;
};

const loadAvailability = async () => {
  if (!props.memberCode) return;
  try {
    const res = await bankbookApi.getReportAvailability(props.memberCode, {
      year: props.currentYear,
      month: props.currentMonth,
      bizGubun: props.bizGubun,
      bankCode: props.bankCode || undefined,
    });
    const data = res?.data?.data || res?.data || {};
    const sections = (data.sections || {}) as Record<string, boolean>;
    // 장부 목차(hasLedgerSectionContent)와 동일 기준 — sections 우선
    const flags: Record<string, boolean> = {
      'ledger-book': true,
      'accounting-analysis': true,
      'income-settlement': sections['income-settlement'] ?? Boolean(data.hasIncome || data.hasAny),
      'expense-settlement': sections['expense-settlement'] ?? Boolean(data.hasExpense || data.hasAny),
      'cash-journal': sections['cash-journal'] ?? Boolean(data.hasAny),
      'general-ledger': sections['general-ledger'] ?? Boolean(data.hasAny),
      'income-resolution': sections['income-resolution'] ?? Boolean(data.hasIncome),
      'expense-resolution': sections['expense-resolution'] ?? Boolean(data.hasExpense),
      'return-resolution': sections['return-resolution'] ?? Boolean(data.hasReturn),
      'subsidy-statement': sections['subsidy-statement'] ?? Boolean(data.hasSubsidyIncome || data.hasSubsidy),
      'subsidy-income-resolution': sections['subsidy-income-resolution'] ?? Boolean(data.hasSubsidyIncome),
      'subsidy-expense-resolution': sections['subsidy-expense-resolution'] ?? Boolean(data.hasSubsidyExpense),
      'donation-statement': sections['donation-statement'] ?? Boolean(data.hasDonation),
      'donation-income-resolution': sections['donation-income-resolution'] ?? Boolean(data.hasDonationIncome),
      'donation-expense-resolution': sections['donation-expense-resolution'] ?? Boolean(data.hasDonationExpense),
    };
    reportList.value = reportList.value.map((report) => ({
      ...report,
      disabled: flags[report.key] === false,
    }));
  } catch (error: any) {
    console.error('보고서 데이터 확인 오류:', error);
    reportList.value = reportList.value.map((report) => ({ ...report, disabled: false }));
  }
};

const currentApprovalLabels = () => approvalLabels.value.map((label) => label.trim());

const setApprovalCount = (count: number) => {
  const preset = APPROVAL_PRESETS[count] || APPROVAL_PRESETS[1];
  const current = currentApprovalLabels();
  const onlyDefault = current.length === 1 && current[0] === '시설장';
  if (onlyDefault) {
    approvalLabels.value = [...preset];
    return;
  }
  const next = current.slice(0, count);
  while (next.length < count) {
    next.push(preset[next.length] || '');
  }
  approvalLabels.value = next;
};

let skipApprovalPersist = false;
let approvalPersistTimer: ReturnType<typeof setTimeout> | null = null;

const persistApprovalLabels = async () => {
  const labels = currentApprovalLabels();
  if (!props.memberCode) return;
  try {
    await bankbookApi.upsertFinanceInfo(props.memberCode, {
      approval_labels: labels.some(Boolean) ? labels.join(',') : '시설장',
    });
  } catch (error: any) {
    console.error('결재란 저장 오류:', error);
  }
};

const refreshSelectedReport = async () => {
  const report = reportList.value.find((r) => r.key === selectedReport.value);
  if (report?.key === 'accounting-analysis') {
    await loadAnalysis();
    return;
  }
  if (report?.pdfKey) {
    await generatePdf(report.pdfKey);
  }
};

const scheduleApprovalChange = () => {
  if (skipApprovalPersist) return;
  if (approvalPersistTimer) clearTimeout(approvalPersistTimer);
  approvalPersistTimer = setTimeout(async () => {
    await persistApprovalLabels();
    await refreshSelectedReport();
  }, 400);
};

const loadApprovalLabels = async () => {
  if (!props.memberCode) return;
  skipApprovalPersist = true;
  try {
    const res = await bankbookApi.getFinanceInfo(props.memberCode);
    const raw = String(res.data?.data?.approval_labels || '');
    const labels = raw.split(',').map((item) => item.trim());
    approvalLabels.value = labels.some(Boolean) ? labels : ['시설장'];
  } catch {
    approvalLabels.value = ['시설장'];
  } finally {
    skipApprovalPersist = false;
  }
};

const analysisPeriodParams = () => {
  const start = clampMonth(analysisStartMonth.value);
  const end = clampMonth(analysisEndMonth.value);
  return {
    year: props.currentYear,
    month: String(end).padStart(2, '0'),
    bizGubun: props.bizGubun,
    bankCode: props.bankCode || undefined,
    periodType: analysisPeriodType.value,
    startMonth: start,
    endMonth: end,
  };
};

const loadAnalysis = async () => {
  if (!props.memberCode) return;
  persistApprovalLabels();
  analysisData.value = null;
  pdfLoading.value = true;
  try {
    const response = await bankbookApi.getAccountingAnalysis(
      props.memberCode,
      analysisPeriodParams()
    );
    analysisData.value = response.data?.data || null;
  } catch (error: any) {
    analysisData.value = null;
    alert(`분석보고서 조회 실패: ${error.response?.data?.message || error.message || '알 수 없는 오류'}`);
  } finally {
    pdfLoading.value = false;
  }
};

const generatePdf = async (reportKey: string) => {
  if (!props.memberCode) return;

  persistApprovalLabels();
  const requestId = ++pdfRequestSeq;
  const periodKeyForRequest = reportKey === 'accounting-analysis'
    ? currentAnalysisPeriodKey.value
    : null;
  if (pdfPreviewUrl.value) {
    URL.revokeObjectURL(pdfPreviewUrl.value);
    pdfPreviewUrl.value = null;
  }
  pdfBlob.value = null;
  pdfSourceKey.value = null;
  if (reportKey === 'accounting-analysis') {
    analysisPdfPeriodKey.value = null;
  }
  pdfLoading.value = true;

  try {
    const analysisParams = reportKey === 'accounting-analysis'
      ? analysisPeriodParams()
      : null;
    const response = await bankbookApi.getResolutionReportPdf(
      props.memberCode,
      reportKey,
      {
        year: props.currentYear,
        month: analysisParams
          ? analysisParams.month
          : props.currentMonth,
        bizGubun: props.bizGubun,
        bankCode: props.bankCode || undefined,
        approvalLabels: currentApprovalLabels().join(',') || '시설장',
        ...(analysisParams
          ? {
              periodType: analysisParams.periodType,
              startMonth: analysisParams.startMonth,
              endMonth: analysisParams.endMonth,
            }
          : {}),
      }
    );

    // 이전에 시작한 장부 등 요청이 늦게 끝나면 무시
    if (requestId !== pdfRequestSeq) return;
    // 생성 중 기간이 바뀌었으면 이 PDF는 버림
    if (
      reportKey === 'accounting-analysis'
      && periodKeyForRequest !== currentAnalysisPeriodKey.value
    ) {
      return;
    }

    pdfBlob.value = new Blob([response.data], { type: 'application/pdf' });
    pdfPreviewUrl.value = URL.createObjectURL(pdfBlob.value);
    pdfSourceKey.value = reportKey;
    analysisPdfPeriodKey.value = reportKey === 'accounting-analysis'
      ? periodKeyForRequest
      : null;
  } catch (error: any) {
    if (requestId !== pdfRequestSeq) return;

    let errorMessage = '알 수 없는 오류';
    const status = error.response?.status || '';

    if (error.response?.data instanceof Blob) {
      try {
        const text = await error.response.data.text();
        const json = JSON.parse(text);
        errorMessage = json.message || errorMessage;
      } catch {
        errorMessage = error.message || errorMessage;
      }
    } else {
      errorMessage = error.response?.data?.message || error.message || errorMessage;
    }

    alert(`PDF 생성 실패: ${errorMessage}${status ? ` (${status})` : ''}`);
  } finally {
    if (requestId === pdfRequestSeq) {
      pdfLoading.value = false;
    }
  }
};

const selectReport = async (reportKey: string) => {
  const report = reportList.value.find((r) => r.key === reportKey);
  if (!report || report.disabled) return;

  if (selectedReport.value === reportKey) return;
  selectedReport.value = reportKey;
  // 진행 중/잔존 PDF가 다른 보고서로 쓰이지 않게 무효화
  pdfRequestSeq += 1;
  revokePdfUrl();

  if (reportKey === 'accounting-analysis') {
    await loadAnalysis();
    return;
  }

  if (report.pdfKey) {
    await generatePdf(report.pdfKey);
  }
};

const reportPageTabs = computed(() => {
  if (!props.page) return [];
  return reportList.value.map((report) => ({
    key: report.key,
    title: report.title,
    disabled: report.disabled,
  }));
});
usePageTabNav('accounting-reports', reportPageTabs, selectedReport, (key) => {
  void selectReport(key);
});

const writePopupHtml = (popup: Window, html: string) => {
  popup.document.open();
  popup.document.write(html);
  popup.document.close();
};

const openAnalysisReferencePopup = async () => {
  if (!props.memberCode || referencePopupLoading.value) return;

  const width = Math.min(1100, screen.availWidth - 40);
  const height = Math.min(900, screen.availHeight - 40);
  const left = Math.max(0, Math.round((screen.availWidth - width) / 2));
  const top = Math.max(0, Math.round((screen.availHeight - height) / 2));
  const popup = window.open(
    'about:blank',
    'caion-accounting-analysis-reference',
    `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
  );
  if (!popup) {
    alert('팝업이 차단되었습니다. 브라우저에서 팝업을 허용한 뒤 다시 시도해 주세요.');
    return;
  }

  writePopupHtml(popup, buildAnalysisReferenceLoadingHtml());
  referencePopupLoading.value = true;
  try {
    const response = await bankbookApi.getAccountingAnalysisReference(
      props.memberCode,
      analysisPeriodParams()
    );
    if (popup.closed) return;
    const data = response.data?.data;
    if (!data) {
      writePopupHtml(popup, buildAnalysisReferenceErrorHtml('계정별내역 데이터가 없습니다.'));
      return;
    }
    writePopupHtml(popup, buildAnalysisReferenceHtml(data));
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || error.message || '알 수 없는 오류';
    if (!popup.closed) {
      writePopupHtml(popup, buildAnalysisReferenceErrorHtml(`계정별내역 조회 실패: ${errorMessage}`));
    }
    alert(`계정별내역 조회 실패: ${errorMessage}`);
  } finally {
    referencePopupLoading.value = false;
  }
};

const downloadPdf = async () => {
  const pdfKey = currentPdfKey.value;
  if (!pdfKey) return;

  // 회계분석은 기간 변경·캐시 꼬임을 막기 위해 항상 현재 기간으로 재생성
  const forceRefresh = pdfKey === 'accounting-analysis'
    || pdfSourceKey.value !== pdfKey
    || !pdfBlob.value
    || (
      pdfKey === 'accounting-analysis'
      && analysisPdfPeriodKey.value !== currentAnalysisPeriodKey.value
    );

  if (forceRefresh) {
    await generatePdf(pdfKey);
  }
  if (pdfSourceKey.value !== pdfKey || !pdfBlob.value) return;
  if (
    pdfKey === 'accounting-analysis'
    && analysisPdfPeriodKey.value !== currentAnalysisPeriodKey.value
  ) {
    return;
  }

  const url = URL.createObjectURL(pdfBlob.value);
  const link = document.createElement('a');
  link.href = url;
  const periodName = pdfKey === 'accounting-analysis'
    ? analysisRange.value.label
    : `${props.currentYear}년${props.currentMonth}월`;
  link.download = `${currentReportTitle.value}_${periodName}.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

onMounted(() => {
  loadApprovalLabels();
});

watch(() => props.memberCode, () => {
  loadApprovalLabels();
});

watch(approvalLabels, () => {
  scheduleApprovalChange();
}, { deep: true });

watch(
  [analysisStartMonth, analysisEndMonth],
  () => {
    const start = clampMonth(analysisStartMonth.value);
    const end = clampMonth(analysisEndMonth.value);
    if (analysisStartMonth.value !== start) analysisStartMonth.value = start;
    if (end < start) {
      if (analysisEndMonth.value !== start) analysisEndMonth.value = start;
      return;
    }
    if (analysisEndMonth.value !== end) analysisEndMonth.value = end;

    // 기간이 바뀌면 이전 PDF(예: 1월 단월)가 남지 않게 무효화
    invalidateAnalysisPdfCache();

    if (selectedReport.value === 'accounting-analysis') {
      loadAnalysis();
    }
  }
);

// 연도 변경 시에만 분석기간을 통장월로 리셋
watch(
  () => props.currentYear,
  () => {
    resetAnalysisMonths(props.currentMonth);
  }
);

// 통장월 변경: 단월 선택 중일 때만 동기화 (1~6 등 확장 기간은 유지)
watch(
  () => props.currentMonth,
  (month) => {
    if (analysisStartMonth.value === analysisEndMonth.value) {
      resetAnalysisMonths(month);
    }
  }
);

watch(
  () => [props.memberCode, props.currentYear, props.currentMonth, props.bizGubun, props.bankCode],
  async () => {
    await loadAvailability();
    if (!selectedReport.value) {
      selectedReport.value = 'accounting-analysis';
    }
    let report = reportList.value.find((r) => r.key === selectedReport.value);
    if (report?.disabled) {
      selectedReport.value = 'accounting-analysis';
      report = reportList.value.find((r) => r.key === 'accounting-analysis');
      revokePdfUrl();
    }
    if (report?.key === 'accounting-analysis') {
      await loadAnalysis();
      return;
    }
    if (report?.pdfKey) {
      await generatePdf(report.pdfKey);
    }
  },
  { immediate: true }
);

onBeforeUnmount(() => {
  if (approvalPersistTimer) clearTimeout(approvalPersistTimer);
  revokePdfUrl();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bankbook-reports-modal", { 'is-page': __props.page }])
  }, [
    _createVNode(LoadingOverlay, {
      show: pdfLoading.value,
      text: loadingText.value
    }, null, 8, ["show", "text"]),
    (!__props.page)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_icon, {
              size: "22",
              color: "white"
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode("mdi-file-chart-outline", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _cache[10] || (_cache[10] = _createElementVNode("h3", null, "회계보고서류", -1)),
            _createElementVNode("p", null, _toDisplayString(__props.currentYear) + "년 " + _toDisplayString(__props.currentMonth) + "월" + _toDisplayString(__props.bizGubun ? ` · ${__props.bizGubun}` : ''), 1)
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "header-spacer" }, null, -1))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("aside", _hoisted_5, [
        _cache[34] || (_cache[34] = _createElementVNode("div", { class: "sidebar-section-title" }, "보고서", -1)),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["report-item report-item--primary", { active: isAnalysisWorkspace.value }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (selectReport('accounting-analysis')))
        }, [
          _createVNode(_component_v_icon, {
            size: "16",
            class: "report-icon"
          }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
              _createTextVNode("mdi-chart-timeline-variant", -1)
            ]))]),
            _: 1
          }),
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "report-text" }, [
            _createElementVNode("span", { class: "report-title" }, "회계분석보고서"),
            _createElementVNode("span", { class: "report-desc" }, "인건비·생계비·차입 점검")
          ], -1))
        ], 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["report-item report-item--primary", { active: isLedgerWorkspace.value }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (selectReport('ledger-book')))
        }, [
          _createVNode(_component_v_icon, {
            size: "16",
            class: "report-icon"
          }, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
              _createTextVNode("mdi-book-open-variant", -1)
            ]))]),
            _: 1
          }),
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "report-text" }, [
            _createElementVNode("span", { class: "report-title" }, "장부"),
            _createElementVNode("span", { class: "report-desc" }, "표지·목차 + 보고서 이어붙임")
          ], -1))
        ], 2),
        (isAnalysisWorkspace.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "sidebar-section-title" }, "분석 기간", -1)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  type: "button",
                  class: "ym-nav-btn",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (changeReportYear(-1)))
                }, [
                  _createVNode(_component_v_icon, { size: "16" }, {
                    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                      _createTextVNode("mdi-chevron-left", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("span", _hoisted_8, _toDisplayString(__props.currentYear) + "년", 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "ym-nav-btn",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (changeReportYear(1)))
                }, [
                  _createVNode(_component_v_icon, { size: "16" }, {
                    default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                      _createTextVNode("mdi-chevron-right", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, [
                  _cache[18] || (_cache[18] = _createElementVNode("span", null, "시작", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((analysisStartMonth).value = $event)),
                    onChange: onRangeSelectChange
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(analysisMonthOptions), (item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: `start-${item.month}`,
                        value: item.month
                      }, _toDisplayString(item.label), 9, _hoisted_11))
                    }), 128))
                  ], 544), [
                    [
                      _vModelSelect,
                      analysisStartMonth.value,
                      void 0,
                      { number: true }
                    ]
                  ])
                ]),
                _cache[20] || (_cache[20] = _createElementVNode("span", { class: "period-range-tilde" }, "~", -1)),
                _createElementVNode("label", _hoisted_12, [
                  _cache[19] || (_cache[19] = _createElementVNode("span", null, "종료", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((analysisEndMonth).value = $event)),
                    onChange: onRangeSelectChange
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(analysisMonthOptions), (item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: `end-${item.month}`,
                        value: item.month,
                        disabled: item.month < analysisStartMonth.value
                      }, _toDisplayString(item.label), 9, _hoisted_13))
                    }), 128))
                  ], 544), [
                    [
                      _vModelSelect,
                      analysisEndMonth.value,
                      void 0,
                      { number: true }
                    ]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(analysisMonthOptions), (item) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: item.month,
                    type: "button",
                    class: _normalizeClass(["period-btn", monthButtonClass(item.month)]),
                    onClick: ($event: any) => (pickAnalysisMonth(item.month))
                  }, _toDisplayString(item.label), 11, _hoisted_15))
                }), 128))
              ]),
              _createElementVNode("p", _hoisted_16, _toDisplayString(analysisPeriodHint.value) + " · 시작·종료를 고르거나 월을 두 번 눌러 기간 선택", 1)
            ]))
          : _createCommentVNode("", true),
        (isAnalysisWorkspace.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _cache[25] || (_cache[25] = _createElementVNode("div", { class: "sidebar-section-title" }, "참고", -1)),
              _cache[26] || (_cache[26] = _createElementVNode("p", { class: "ledger-detail-hint" }, "클릭하면 새 창에서 계정별내역을 엽니다.", -1)),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["report-item report-item--detail", { loading: referencePopupLoading.value }]),
                disabled: referencePopupLoading.value,
                onClick: openAnalysisReferencePopup
              }, [
                _createVNode(_component_v_icon, {
                  size: "15",
                  class: "report-icon"
                }, {
                  default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                    _createTextVNode("mdi-book-open-page-variant-outline", -1)
                  ]))]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_19, [
                  _cache[23] || (_cache[23] = _createElementVNode("span", { class: "report-title" }, "계정별내역", -1)),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(referencePopupLoading.value ? '새 창으로 여는 중...' : '계정합계 · 전표 · 새 창'), 1)
                ]),
                (!referencePopupLoading.value)
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 0,
                      size: "14",
                      class: "report-open-icon"
                    }, {
                      default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                        _createTextVNode("mdi-open-in-new", -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_18)
            ]))
          : _createCommentVNode("", true),
        (isLedgerWorkspace.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_21, [
                _cache[29] || (_cache[29] = _createElementVNode("div", { class: "sidebar-section-title" }, "연월", -1)),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "ym-nav-btn",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (changeLedgerMonth(-1)))
                  }, [
                    _createVNode(_component_v_icon, { size: "16" }, {
                      default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                        _createTextVNode("mdi-chevron-left", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", {
                    class: "ledger-ym-display",
                    onClick: openLedgerMonthPicker
                  }, [
                    _createElementVNode("span", _hoisted_23, _toDisplayString(__props.currentYear) + "." + _toDisplayString(__props.currentMonth), 1),
                    _createElementVNode("input", {
                      type: "month",
                      ref_key: "ledgerMonthPickerRef",
                      ref: ledgerMonthPickerRef,
                      value: `${__props.currentYear}-${__props.currentMonth}`,
                      onChange: onLedgerMonthPickerChange,
                      onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
                      class: "hidden-month-picker"
                    }, null, 40, _hoisted_24)
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "ym-nav-btn",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (changeLedgerMonth(1)))
                  }, [
                    _createVNode(_component_v_icon, { size: "16" }, {
                      default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                        _createTextVNode("mdi-chevron-right", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _cache[31] || (_cache[31] = _createElementVNode("div", { class: "sidebar-section-title" }, "결재란", -1)),
                _createElementVNode("div", _hoisted_26, [
                  _cache[30] || (_cache[30] = _createElementVNode("span", { class: "approval-count-label" }, "칸 수", -1)),
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4], (count) => {
                    return _createElementVNode("button", {
                      key: count,
                      type: "button",
                      class: _normalizeClass(["approval-count-btn", { active: approvalLabels.value.length === count }]),
                      onClick: ($event: any) => (setApprovalCount(count))
                    }, _toDisplayString(count), 11, _hoisted_27)
                  }), 64))
                ]),
                _createElementVNode("div", _hoisted_28, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(approvalLabels.value, (_, idx) => {
                    return (_openBlock(), _createElementBlock("label", {
                      key: idx,
                      class: "approval-field"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(idx + 1) + "칸", 1),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": ($event: any) => ((approvalLabels.value[idx]) = $event),
                        type: "text",
                        maxlength: "8",
                        placeholder: "직함"
                      }, null, 8, _hoisted_29), [
                        [_vModelText, approvalLabels.value[idx]]
                      ])
                    ]))
                  }), 128))
                ]),
                _createVNode(MemberStampPanel, { "member-code": __props.memberCode }, null, 8, ["member-code"])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _cache[32] || (_cache[32] = _createElementVNode("div", { class: "sidebar-section-title" }, "세부내역", -1)),
                _cache[33] || (_cache[33] = _createElementVNode("p", { class: "ledger-detail-hint" }, "목차 보고서를 하나씩 확인할 수 있습니다.", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailReportList.value, (report) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: report.key,
                    type: "button",
                    class: _normalizeClass(["report-item report-item--detail", {
                  active: selectedReport.value === report.key,
                  disabled: report.disabled,
                }]),
                    disabled: report.disabled,
                    onClick: ($event: any) => (selectReport(report.key))
                  }, [
                    _createVNode(_component_v_icon, {
                      size: "15",
                      class: "report-icon"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(report.icon), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("span", _hoisted_33, _toDisplayString(report.title), 1)
                    ]),
                    (report.disabled)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_34, "데이터 없음"))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_31))
                }), 128)),
                (detailReportList.value.length === 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_35, " 표시할 세부 보고서가 없습니다. "))
                  : _createCommentVNode("", true)
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("main", _hoisted_36, [
        (!selectedReport.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              _createVNode(_component_v_icon, {
                size: "48",
                color: "#cbd5e1"
              }, {
                default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                  _createTextVNode("mdi-file-document-outline", -1)
                ]))]),
                _: 1
              }),
              _cache[36] || (_cache[36] = _createElementVNode("p", null, "회계분석보고서 또는 장부를 선택하세요", -1))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("span", _hoisted_40, _toDisplayString(currentReportTitle.value), 1),
                _createElementVNode("div", _hoisted_41, [
                  (activePdfPreviewUrl.value)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: activePdfPreviewUrl.value,
                        target: "_blank",
                        rel: "noopener",
                        class: "btn-pdf-download ghost"
                      }, [
                        _createVNode(_component_v_icon, { size: "14" }, {
                          default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                            _createTextVNode("mdi-open-in-new", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[38] || (_cache[38] = _createTextVNode(" PDF 열기 ", -1))
                      ], 8, _hoisted_42))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-pdf-download",
                    disabled: pdfLoading.value || (selectedReport.value !== 'accounting-analysis' && !activePdfBlob.value),
                    onClick: downloadPdf
                  }, [
                    _createVNode(_component_v_icon, { size: "14" }, {
                      default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                        _createTextVNode("mdi-download", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[40] || (_cache[40] = _createTextVNode(" PDF 다운로드 ", -1))
                  ], 8, _hoisted_43)
                ])
              ]),
              (pdfLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      color: "#1e3a5f",
                      size: "36"
                    }),
                    _createElementVNode("span", null, _toDisplayString(loadingText.value), 1)
                  ]))
                : (selectedReport.value === 'accounting-analysis' && analysisData.value)
                  ? (_openBlock(), _createBlock(AccountingAnalysisPanel, {
                      key: 1,
                      data: analysisData.value,
                      "member-code": __props.memberCode,
                      year: __props.currentYear,
                      month: String(analysisEndMonth.value),
                      "biz-gubun": __props.bizGubun,
                      "period-type": analysisPeriodType.value,
                      "start-month": analysisStartMonth.value,
                      "end-month": analysisEndMonth.value,
                      onSaved: loadAnalysis
                    }, null, 8, ["data", "member-code", "year", "month", "biz-gubun", "period-type", "start-month", "end-month"]))
                  : (activePdfPreviewUrl.value && supportsInlinePdf.value)
                    ? (_openBlock(), _createElementBlock("iframe", {
                        key: 2,
                        src: activePdfPreviewUrl.value,
                        class: "pdf-iframe",
                        title: "보고서 미리보기"
                      }, null, 8, _hoisted_45))
                    : (activePdfPreviewUrl.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _createVNode(_component_v_icon, {
                            size: "48",
                            color: "#1e3a5f"
                          }, {
                            default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                              _createTextVNode("mdi-file-pdf-box", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[46] || (_cache[46] = _createElementVNode("p", null, "이 기기에서는 미리보기를 바로 띄울 수 없습니다.", -1)),
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("a", {
                              href: activePdfPreviewUrl.value,
                              target: "_blank",
                              rel: "noopener",
                              class: "btn-pdf-download"
                            }, [
                              _createVNode(_component_v_icon, { size: "16" }, {
                                default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                                  _createTextVNode("mdi-open-in-new", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[43] || (_cache[43] = _createTextVNode(" PDF 열기 ", -1))
                            ], 8, _hoisted_48),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn-pdf-download ghost",
                              onClick: downloadPdf
                            }, [
                              _createVNode(_component_v_icon, { size: "16" }, {
                                default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                                  _createTextVNode("mdi-download", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[45] || (_cache[45] = _createTextVNode(" 다운로드 ", -1))
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                          _createVNode(_component_v_icon, {
                            size: "48",
                            color: "#cbd5e1"
                          }, {
                            default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                              _createTextVNode("mdi-file-pdf-box", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[48] || (_cache[48] = _createElementVNode("p", null, "미리보기를 불러올 수 없습니다", -1))
                        ]))
            ]))
      ])
    ])
  ], 2))
}
}

})